const chosenPlace = ref('Chomutov')

export const usePlaces = () => {
  const places = [
    {
      name: 'Chomutov',
      address: 'Kukaňova 2262',
      city: '430 03 Chomutov',
      phone: '(+420) 474 721 000',
      tel: 'tel:+420474721000',
      googleSrc:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d635.0190507027379!2d13.397222644874317!3d50.45830565984638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470a1b10a5109d39%3A0xdfeca8a31544c964!2sKuka%C5%88ova%202262%2F18%2C%20430%2003%20Chomutov%203!5e0!3m2!1scs!2scz!4v1725889457057!5m2!1scs!2scz',
    },
    {
      name: 'Žatec',
      address: 'Volyňských Čechů 837',
      city: '438 01 Žatec',
      phone: '(+420) 415 210 556',
      tel: 'tel:+420415210556',
      googleSrc:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2547.3167825301693!2d13.540582813022226!3d50.323340896388046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470a3ded6b938f11%3A0xf04ba4c5dfc3b0b6!2zVm9secWIc2vDvWNoIMSMZWNoxa8gODM3LCA0MzggMDEgxb1hdGVjIDE!5e0!3m2!1scs!2scz!4v1726656820922!5m2!1scs!2scz',
    },
    {
      name: 'Louny',
      address: 'Hilbertova 465',
      city: '440 01 Louny',
      phone: '(+420) 415 658 103',
      tel: 'tel:+420415658103',
      googleSrc:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2545.502716561382!2d13.796995313023398!3d50.35717989395547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470a301e03d06861%3A0x5808d280b311acfe!2sHilbertova%20465%2C%20440%2001%20Louny%201!5e0!3m2!1scs!2scz!4v1726657006364!5m2!1scs!2scz',
    },
  ]

  return {
    chosenPlace,
    places,
  }
}
